import React from "react";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { Form, RootState } from "../../../../../../models";
import { FieldSet, Input } from "../../../../forms";
import { RapidForm } from "../../../../rapidform";
import { VALIDATION_FIELD } from "../../../../rapidform/formValidation";
import { getFormById } from "../../../state/selectors";
import TEXT from "../../../text-consts";
import "./RefillPrepaidEmailForm.less";

interface StateProps {
    prepaidRefillForm: Form;
}

interface RefillPrepaidEmailForm extends StateProps {
    onSubmitDetails: () => void;
}

const RefillPrepaidEmailForm: React.FC<RefillPrepaidEmailForm> = ({ prepaidRefillForm, onSubmitDetails }) => {
    return (
        <RapidForm
            id={FORM_ID.REFILL_PREPAID}
            action={"#"}
            errors={prepaidRefillForm.errors}
            values={prepaidRefillForm.values}
            visible={prepaidRefillForm.visible}
            started={prepaidRefillForm.started}
            onSubmit={onSubmitDetails}
        >
            <FieldSet name="prepaidEmail">
                <Input
                    className="refill-prepaid-form__email-field"
                    type="text"
                    name={VALIDATION_FIELD.EMAIL}
                    label={`${TEXT.REFILL.EMAIL_INPUT_LABEL}:`}
                    data-di-mask
                    helpText={TEXT.REFILL.EMAIL_HELP_TEXT}
                />
            </FieldSet>
        </RapidForm>
    );
};
const mapStateToProps = (state: RootState): StateProps => ({
    prepaidRefillForm: getFormById(state, FORM_ID.REFILL_PREPAID),
});

export default connect(mapStateToProps)(RefillPrepaidEmailForm);
